module.exports = __webpack_public_path__ + "img/sumUpload.597863d3.png";